console.log("[variant-media] variant-media-by-color.js loaded in", window.location.href);

(function () {
  function norm(s) {
    return (s || "").toString().trim().toLowerCase();
  }

  // ----------------------------
  // Helpers
  // ----------------------------
  function isInModal(el) {
    return !!(el && el.closest && el.closest("xo-modal, [role='dialog'], .modal, .drawer"));
  }

  function looksLikeRealProductMediaImg(img) {
    if (!img) return false;
    const src = (img.currentSrc || img.src || "").toLowerCase();
    if (!src) return false;
    if (!src.includes("cdn.shopify.com")) return false;

    const w = img.naturalWidth || img.width || 0;
    const h = img.naturalHeight || img.height || 0;
    if (w && h && (w < 200 || h < 200)) return false;

    return true;
  }

  function getFilenameFromImg(img) {
    try {
      const src = img.currentSrc || img.src || "";
      if (!src) return "";
      const noQuery = src.split("?")[0];
      const parts = noQuery.split("/");
      return parts[parts.length - 1] || "";
    } catch (e) {
      return "";
    }
  }

  // Find the "gallery root" by looking for the ancestor that contains the MOST Shopify CDN images
  function getGalleryRoot() {
    const imgs = Array.from(document.querySelectorAll("img"))
      .filter((img) => !isInModal(img))
      .filter(looksLikeRealProductMediaImg);

    if (!imgs.length) return null;

    const score = new Map();

    imgs.forEach((img) => {
      let el = img.parentElement;
      let hops = 0;
      while (el && hops < 10) {
        // avoid body/html
        if (el === document.body || el === document.documentElement) break;

        const key = el;
        score.set(key, (score.get(key) || 0) + 1);

        el = el.parentElement;
        hops++;
      }
    });

    let best = null;
    let bestScore = 0;

    for (const [el, s] of score.entries()) {
      // Prefer something "section-ish" sized, not tiny wrappers
      if (s > bestScore) {
        best = el;
        bestScore = s;
      }
    }

    return best;
  }

  function getVariantId() {
    const idInput =
      document.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('[name="id"]');
    return idInput && idInput.value ? String(idInput.value) : null;
  }

  function getProductJson() {
    const scripts = document.querySelectorAll('script[type="application/json"]');
    for (const el of scripts) {
      const txt = el.textContent || "";
      if (txt.includes('"variants"') && txt.includes('"options"')) {
        try {
          const parsed = JSON.parse(txt);
          if (parsed && parsed.variants) return parsed;
        } catch (e) {}
      }
    }
    return null;
  }

  function getSelectedColor() {
    const vid = getVariantId();
    const product = getProductJson();

    if (vid && product && Array.isArray(product.variants)) {
      const v = product.variants.find((x) => String(x.id) === String(vid));
      if (v && Array.isArray(v.options) && v.options.length) return v.options[0];
      if (v && v.option1) return v.option1;
    }

    const checked = document.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;

    const select = document.querySelector(
      'select[name*="option"], select[name*="colour"], select[name*="color"]'
    );
    if (select) return select.value;

    return null;
  }

  // For main image hiding, hide the "tile" container, not just the <img>
  function getHideContainer(img) {
    return (
      img.closest(".swiper-slide") ||
      img.closest(".splide__slide") ||
      img.closest("[data-media-id]") ||
      img.closest("[data-product-media]") ||
      img.closest(".product__media") ||
      img.closest(".product-media") ||
      img.closest(".media") ||
      img.closest("li") ||
      img.closest("figure") ||
      img
    );
  }

  // Find the thumbnail strip container INSIDE galleryRoot (so we don't touch header/menu)
  function findThumbStrip(galleryRoot) {
    if (!galleryRoot) return null;

    const all = Array.from(galleryRoot.querySelectorAll("*"));
    const candidates = all
      .map((el) => {
        const children = Array.from(el.children || []);
        if (children.length < 4 || children.length > 40) return null;

        // children that are "tile-ish"
        const tileKids = children.filter((c) =>
          ["BUTTON", "A", "LI", "DIV"].includes(c.tagName)
        );
        if (tileKids.length < 4) return null;

        const r = el.getBoundingClientRect();
        if (!r || r.width < 200) return null;
        // thumb strip tends to be short height
        if (r.height > 180) return null;

        return { el, height: r.height, tiles: tileKids.length };
      })
      .filter(Boolean);

    if (!candidates.length) return null;

    // smallest height usually corresponds to thumbs row
    candidates.sort((a, b) => a.height - b.height);
    return candidates[0].el;
  }

  function isBlankThumbTile(tile) {
    if (!tile) return false;

    // if it contains a real shopify image, it's not blank
    const img = tile.querySelector && tile.querySelector("img");
    if (img && looksLikeRealProductMediaImg(img)) return false;

    // detect "loading dots" or empty content
    const text = (tile.textContent || "").trim();
    if (!text) return true;

    // dots / bullets / "1 / 11" patterns
    if (/^[•.\s]+$/.test(text)) return true;
    if (/^\d+\s*\/\s*\d+$/.test(text)) return true;

    // also blank if it has no meaningful children
    const hasAnyElementChild = tile.querySelector && tile.querySelector("*");
    if (!hasAnyElementChild) return true;

    return false;
  }

  function applyFilter() {
    const color = getSelectedColor();
    if (!color) return;

    const selected = norm(color);
    const galleryRoot = getGalleryRoot();

    if (!galleryRoot) return;

    // only images inside the gallery root
    const imgs = Array.from(galleryRoot.querySelectorAll("img"))
      .filter((img) => !isInModal(img))
      .filter(looksLikeRealProductMediaImg);

    // If no images, nothing to do
    if (!imgs.length) return;

    const COLOR_KEYS = ["sage", "onyx", "chalk", "thistle", "blush"];

    const data = imgs.map((img) => {
      const filename = norm(getFilenameFromImg(img));
      return {
        img,
        container: getHideContainer(img),
        filename,
      };
    });

    const colorImgs = data.filter((x) => COLOR_KEYS.some((k) => x.filename.includes(k)));

    // If we can’t detect any colour images, do nothing (avoids nuking random images)
    if (colorImgs.length === 0) return;

    // Decide which filenames are visible
    const visibleFilenames = new Set();

    data.forEach(({ filename }) => {
      const isColorImg = COLOR_KEYS.some((k) => filename.includes(k));
      const shouldShow = !isColorImg || filename.includes(selected);
      if (shouldShow) visibleFilenames.add(filename);
    });

    // Hide/show main media containers
    data.forEach(({ container, filename }) => {
      const isColorImg = COLOR_KEYS.some((k) => filename.includes(k));

      let shouldShow = false;
      if (!isColorImg) {
        shouldShow = true; // lifestyle/generic always visible
      } else {
        shouldShow = filename.includes(selected);
      }

      try {
        container.style.display = shouldShow ? "" : "none";
      } catch (e) {}
    });

    // ----------------------------
    // Remove blank thumbnail tiles
    // ----------------------------
    const strip = findThumbStrip(galleryRoot);
    if (strip) {
      const tiles = Array.from(strip.children || []);
      tiles.forEach((tile) => {
        // If the tile contains an image, hide it if that image is hidden by our filter
        const img = tile.querySelector && tile.querySelector("img");
        if (img && looksLikeRealProductMediaImg(img)) {
          const filename = norm(getFilenameFromImg(img));
          const isColorImg = COLOR_KEYS.some((k) => filename.includes(k));

          const shouldShowTile = !isColorImg || filename.includes(selected);
          tile.style.display = shouldShowTile ? "" : "none";
          return;
        }

        // Otherwise, hide tiles that are now "blank/loading" placeholders
        if (isBlankThumbTile(tile)) {
          tile.style.display = "none";
        }
      });

      // If current selected/active tile became hidden, click first visible tile (prevents "no main image" edge cases)
      const firstVisible = tiles.find((t) => t && t.style.display !== "none");
      if (firstVisible && firstVisible.click) {
        // only click if main image area has become empty (rare)
        // (safe guard: don't spam clicks)
      }
    }
  }

  function bind() {
    applyFilter();

    document.addEventListener("change", () => setTimeout(applyFilter, 150));
    document.addEventListener("click", () => setTimeout(applyFilter, 150));
    document.addEventListener("shopify:section:load", () => setTimeout(applyFilter, 250));

    // themes often re-render galleries after load
    setTimeout(applyFilter, 600);
    setTimeout(applyFilter, 1600);
    setTimeout(applyFilter, 2600);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();
